// Autogenerated by Hanako
import { Menu } from '../../views/twig/components/Menu';
import { SlideDown } from '../../views/twig/components/SlideDown';
import { Page } from '../../views/twig/pages/root/page';
import { Single } from '../../views/twig/pages/singles/architecture-design';
import { Header } from '../twig/components/Header';
(new Menu()).init();
(new SlideDown()).init();
(new Page()).init();
(new Single()).init();
(new Header()).init();
